import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const chartColors = {
    Allocated: "#6A1B9A",      // Purple
    Installed: "#4CAF50",      // Green
    Remaining: "#FFB300"       // Yellow/Orange
};

function ChartElement({ chartData, height = 400 }) {
    // Get screen width for mobile adjustments only
    const isMobile = window.innerWidth <= 768;

    return (
        <div className="d-flex justify-content-center">
            <ResponsiveContainer width="100%" height={isMobile ? 300 : height}>
                <BarChart
                    data={chartData}
                    margin={{
                        top: isMobile ? 10 : 20,
                        right: isMobile ? 10 : 30,
                        left: isMobile ? 10 : 20,
                        bottom: isMobile ? 10 : 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis 
                        dataKey="name" 
                        tick={{ fontSize: isMobile ? 10 : 12 }}
                        angle={isMobile ? -45 : 0}
                        textAnchor={isMobile ? "end" : "middle"}
                        height={isMobile ? 60 : 30}
                    />
                    <YAxis 
                        tick={{ fontSize: isMobile ? 10 : 12 }}
                        width={isMobile ? 40 : 60}
                    />
                    <Tooltip 
                        contentStyle={{
                            fontSize: isMobile ? '12px' : '14px',
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            border: '1px solid #ccc',
                            borderRadius: '4px'
                        }}
                    />
                    <Legend 
                        wrapperStyle={{
                            fontSize: isMobile ? '10px' : '12px',
                            paddingTop: isMobile ? '10px' : '20px'
                        }}
                    />
                    <Bar dataKey="Allocated" stackId="a" fill={chartColors.Allocated} />
                    <Bar dataKey="Installed" stackId="a" fill={chartColors.Installed} />
                    <Bar dataKey="Remaining" stackId="a" fill={chartColors.Remaining} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default ChartElement; 